import angular from 'angular';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';

class WindowDimensionsService {
    constructor($injector) {
        this.$injector = $injector;
        this.sashesJson = [];
        this.verticalDividersLength = 0;
        this.horizontalDividersLength = 0;
        this.width = 0;
        this.height = 0;
        this.bottomPannel = 0;
        this.bottomPannelCreateFlag = false;
        this.isSplitHorDiv = true;
        this.multiplierHor = 1;
        this.multiplierVert = 1;
        this.mullionsVert = 0;
        this.mullionsHor = 0;
        this.initialSashes = [];
        this.sashesPerWidth = 0;
        this.sashesPerHeight = 0;
        this.level = 1;
        this.grill = null;
        this.topLightFields = 0;
        this.standardFields = 0;
        this.windowWidths = [];
        this.maxBarsVert = 0;
        this.maxBarsHor = 0;
        this.topLightHeight = 0;
        this.dimensionsData = { width: 0, height: 0 };
        this.showWindowTiltHingeSide = false;
        this.hideHingeSide = false;
        this.customWindow = true;
        this.noNewMullions = true;
    }

    setGrill(id) {
        this.grill = id;
    }

    convertIntSashIndex(index, direction, lengthX, lengthY) {
        let newIndex = index;

        if (this.isSplitHorDiv && direction === 'horizontal') {
            newIndex = Math.floor((index - (lengthX - 1)) / lengthX);
        } else if (!this.isSplitHorDiv && direction === 'horizontal') {
            newIndex = Math.floor((index - (lengthY - 1)) / lengthY);
        }

        return newIndex;
    }

    getBottomPannel() {
        return this.bottomPannel;
    }

    getHorizontalDividersLength() {
        return this.horizontalDividersLength;
    }

    getIntDividerLength(direction, sash) {
        if (this.isSplitHorDiv && direction === 'vertical') {
            return this.getBottomPannel();
        } else if (this.isSplitHorDiv && direction === 'horizontal') {
            return this.getIntSashWidth(sash);
        } else if (!this.isSplitHorDiv && direction === 'horizontal') {
            return sash.width;
        }

        return this.getIntSashHeight();
    }

    getIntDividerPosition(direction, sash) {
        if (direction === 'vertical') {
            return sash.width;
        }

        return this.getIntSashHeight();
    }

    getIntSashHeight() {
        return (this.getBottomPannel() / (this.getHorizontalDividersLength() + 1)) / this.level;
    }

    getIntSashWidth(sash) {
        return sash.width / (this.getVerticalDividersLength() + 1);
    }

    getMullionsHor() {
        return this.mullionsHor;
    }

    getMullionsVert() {
        return this.mullionsVert;
    }

    getSashHeight(sashIndex, bottomPannel) {
        this.sashHeight = this.height;

        if (bottomPannel) {
            return this.bottomPannel;
        }

        if (this.topLightFields === 0) {
            return this.sashHeight;
        }

        if (this.customWindow && this.topLightFields > 0) {
            return this.sashHeight / 2;
        }

        if (sashIndex < this.topLightFields) {
            return this.topLightHeight;
        }
        return this.sashHeight - this.topLightHeight;
    }

    getSashLength(direction) {
        let count = 1;

        forEach(this.initialSashes, (el) => {
            if (direction === 'horizontal' && el.nearDividers.top === -1 && el.nearDividers.right !== -1) {
                count++;
            } else if (direction === 'vertical' && el.nearDividers.right === -1 && el.nearDividers.top !== -1) {
                count++;
            }
        });

        return count;
    }

    getSashWidth(sashIndex) {
        if (angular.isDefined(this.windowWidths) &&
            angular.isDefined(sashIndex) &&
            angular.isDefined(this.windowWidths[sashIndex])) {
            return this.windowWidths[sashIndex];
        }

        this.sashWidth = this.width / this.sashesPerWidth;
        return this.sashWidth;
    }

    getStandardFields() {
        return this.standardFields;
    }

    getTopLightFields() {
        return this.topLightFields;
    }

    getVerticalDividersLength() {
        return this.verticalDividersLength;
    }

    isBottomPannel() {
        return this.bottomPannel < this.height;
    }

    isBottomPannelCreated() {
        return this.bottomPannelCreateFlag;
    }

    isBottomPannelToRemove() {
        return (!this.isBottomPannel() && this.bottomPannelCreateFlag);
    }

    setBottomPannel(height) {
        this.bottomPannel = height;
    }

    setBottomPannelCreateFlag(value) {
        this.bottomPannelCreateFlag = value;
    }

    setHorizontalDividersLength(horizontalDividersLength) {
        this.updateDataAttribute('dividersHorizontal', horizontalDividersLength);
        this.horizontalDividersLength = horizontalDividersLength;

        if (this.isSplitHorDiv) {
            this.multiplierHor = this.verticalDividersLength + 1;
        } else {
            this.multiplierHor = 1;
            this.multiplierVert = horizontalDividersLength + 1;
        }
    }

    setVerticalDividersLength(verticalDividersLength) {
        this.updateDataAttribute('dividersVertical', verticalDividersLength);
        this.verticalDividersLength = verticalDividersLength;

        if (!this.isSplitHorDiv) {
            this.multiplierVert = this.horizontalDividersLength + 1;
        } else {
            this.multiplierVert = 1;
            this.multiplierHor = verticalDividersLength + 1;
        }
    }

    setMullionsVert(value) {
        this.updateDataAttribute('muntinsVertical', value);
        this.mullionsVert = value;
    }

    setMullionsHor(value) {
        this.updateDataAttribute('muntinsHorizontal', value);
        this.mullionsHor = value;
    }

    updateDataAttribute(attribute, value) {
        // Dirty way to avoid circular dependency error without spending time to refactor code...
        setTimeout(() => {
            const dataService = this.$injector.get('dataService');

            if (angular.isDefined(dataService.data.data)) {
                dataService.updateDataAttribute(attribute, value);
            }
        });
    }

    setInitialData(jsonObject) {
        this.initialSashes = cloneDeep(jsonObject.sashes);
        this.sashesPerWidth = this.getSashLength('horizontal');
        this.sashesPerHeight = this.getSashLength('vertical');
    }

    setIsSplitHorDiv(value) {
        this.isSplitHorDiv = value;
    }

    setLevel(value) {
        this.level = value;
    }

    setSashesJson(sashesJson) {
        this.sashesJson = sashesJson;
    }

    setStandardFields(value) {
        this.standardFields = value;
    }

    setTopLightFields(value) {
        this.topLightFields = value;
    }

    setTopLightHeight(value) {
        this.topLightHeightPercentage = value / this.height;
        this.topLightHeight = value;
    }

    setWindowHeight(height) {
        this.height = height;
        this.maxBarsHor = Math.floor((height / 150) / (this.topLightFields === 0 ? 1 : 2)) - 1;
    }

    setWindowWidth(width) {
        this.width = width;
        this.maxBarsVert = Math.floor((width / 150) / Math.max(this.standardFields, this.topLightFields)) - 1;
        this.windowWidths = [];

        const standardFields = this.standardFields;
        const topLightFields = this.topLightFields;

        for (let i = 0; i < topLightFields; ++i) {
            this.windowWidths.push(this.width / topLightFields);
        }
        for (let i = 0; i < standardFields; ++i) {
            this.windowWidths.push(this.width / standardFields);
        }
    }
}

WindowDimensionsService.$inject = [
    '$injector'
];

export default angular.module('windowDimensionsService', [])
    .service('windowDimensionsService', WindowDimensionsService)
    .name;